import { useQuery } from '@tanstack/vue-query';
import * as BasketApi from '@/api/basket';
import { queries } from '@/api/queries';

const useGetBaskets = () => {
  return useQuery({ ...queries.baskets.all, queryFn: BasketApi.getBaskets, retry: 0 });
};

export default useGetBaskets;
